import { render, staticRenderFns } from "./CardInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=template&id=7816df1c&scoped=true&lang=pug"
import script from "./CardInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=script&lang=js"
export * from "./CardInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=script&lang=js"
import style0 from "./CardInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=style&index=0&id=7816df1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816df1c",
  null
  
)

export default component.exports